import { render, staticRenderFns } from "./TopInfo.vue?vue&type=template&id=28719c89&scoped=true&"
import script from "./TopInfo.vue?vue&type=script&lang=js&"
export * from "./TopInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopInfo.vue?vue&type=style&index=0&id=28719c89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28719c89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-company(微信公众号-企业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('28719c89', component.options)
    } else {
      api.reload('28719c89', component.options)
    }
    module.hot.accept("./TopInfo.vue?vue&type=template&id=28719c89&scoped=true&", function () {
      api.rerender('28719c89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/enterprise/demand/shared/TopInfo.vue"
export default component.exports